/**
 * 顯示用數字千分位（唯讀 UI；勿用於表單 input／API payload）。
 */

export function formatDisplayNumber(value, {
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
} = {}) {
  if (value == null || value === '') {
    return '—';
  }
  const number = Number(value);
  if (Number.isNaN(number)) {
    return String(value);
  }
  return number.toLocaleString('zh-TW', {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

export function formatDisplayQty(value) {
  return formatDisplayNumber(value);
}

export function formatDisplayAmount(value) {
  return formatDisplayNumber(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
